import { SearchFlowContext, useSearchFlowReducer } from "./useSearchFlow";
import { useIsFetching } from "@tanstack/react-query";
import { useMemo } from "react";
import { useModal } from "@ebay/nice-modal-react";
import type { ExistingPatientResult } from "api/responses";

/** Provides context for a flow for searching for a patient or insurance carrier and then performing some work. */
export const SearchFlowContextProvider = ({ children }: React.PropsWithChildren<object>) => {
    const modal = useModal();
    const [state, dispatch] = useSearchFlowReducer();
    const isProvisioning = useIsFetching({ queryKey: ["provisionTransactor"], exact: false }) > 0;

    const contextValue = useMemo(() => {
        return {
            ...state,
            modal,
            isProvisioning,
            onSelectNewPrp: () => {
                dispatch({
                    type: "select-new-patient",
                });
            },
            onSelectExistingPrp: (existingPrp: ExistingPatientResult) => {
                dispatch({
                    type: "select-existing-patient",
                    existingPrp,
                });
            },
            onSelectInsuranceCarrier: (name: string) => {
                dispatch({
                    type: "select-insurance-carrier",
                    name,
                });
            },
            onReset: () => {
                dispatch({
                    type: "reset",
                });
            },
        };
    }, [state, dispatch, modal, isProvisioning]);

    return <SearchFlowContext value={contextValue}>{children}</SearchFlowContext>;
};
